export default __webpack_public_path__ + "static/media/trashltt.3ef8bba5.svg";